import Icon from "components/AppIcon";
import React from "react";

const TagsCrudTable = ({
  tags,
  metaTags,
  language,
  onEdit,
  onDelete,
  onPageChange,
}) => {
  if (!metaTags) return null;

  const { current_page, last_page } = metaTags;
  const pages = Array.from({ length: last_page }, (_, i) => i + 1);

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1000px] text-center">
          <thead className="bg-muted border-b">
            <tr>
              <th className="px-6 py-4">الصورة</th>
              <th className="px-6 py-4">الاسم</th>
              <th className="px-6 py-4">الوصف</th>
              <th className="px-6 py-4">تابع لسيارة</th>
              <th className="px-6 py-4">منتج</th>
              <th className="px-6 py-4">ورشة</th>
               <th className="px-6 py-4">طوارئ</th>
              <th className="px-6 py-4">إجراءات</th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {tags?.map((tag) => (
              <tr key={tag.id} className="hover:bg-muted/40 transition">
                {/* Image */}
                <td className="px-6 py-4">
                  {tag?.image?.media_link ? (
                    <img
                      src={tag.image.media_link}
                      alt={tag.name}
                      className="w-12 h-12 mx-auto rounded object-cover"
                    />
                  ) : (
                    <div className="w-12 h-12 mx-auto flex items-center justify-center bg-gray-100 rounded">
                      <Icon name="Image" size={16} />
                    </div>
                  )}
                </td>

                {/* Name */}
                <td>{tag.name}</td>

                {/* Description */}
                <td className="max-w-xs truncate">
                  {tag.description}
                </td>

                {/* Flags */}
                <td>{tag.is_car ? "نعم" : "لا"}</td>
                <td>{tag.is_product ? "نعم" : "لا"}</td>
                <td>{tag.is_workshop ? "نعم" : "لا"}</td>
        <td>{tag.is_emergency ? "نعم" : "لا"}</td>
                {/* Actions */}
                <td className="px-6 py-4">
                  <div className="flex justify-center gap-2">
                    <button
                      onClick={() => onEdit(tag)}
                      className="p-2 rounded-lg hover:bg-primary/10 text-primary transition"
                    >
                      <Icon name="Edit2" size={16} />
                    </button>

                    <button
                      onClick={() => onDelete(tag)}
                      className="p-2 rounded-lg hover:bg-error/10 text-error transition"
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-center gap-2 p-4">
        {pages.map((p) => (
          <button
            key={p}
            onClick={() => onPageChange(p)}
            className={`px-3 py-1 rounded ${
              p === current_page
                ? "bg-primary text-white"
                : "bg-muted"
            }`}
          >
            {p}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TagsCrudTable;